import React, { Component, useImperativeHandle } from 'react';
import CardHeader from '../component/card/cardHeader';
import Time from '../component/header/time/time';
import StudentInfo from '../component/studentInfo/studentInfo';
import '../css/seatSelect.css';
import { BrowserRouter as Router,Route,Link } from 'react-router-dom';


class SeatSelect extends Component {
    state = {
        selectClass: false,
        selectedNum: '',
        pageMove: ''
    };

    handleInfo = (event) => {
        const selectedNum = this.state.selectedNum;
        this.setState({selectedNum: event.target.value});
        
        const pageMove = this.state.pageMove;
        this.setState({pageMove: `/login/${event.target.value}`});
        //console.log(`event.target.value: ${event.target.value}, pageMove: ${this.state.pageMove}`);

        const selectClass = this.state.selectClass;
        this.setState({selectClass: true});
    }

    handleSubmit = (event) => {
        event.preventDefault();
        // console.log(`selectedNum: ${this.state.selectedNum}, pageMove: ${this.state.pageMove}`);
    };

    render() {
        return (
            <div className="wrap d-flex seat-select-wrap flex-column">
                <header className="d-flex align-items-center justify-content-between">
                    <div className="d-flex flex-grow-1 align-items-center justify-content-between">
                        <div className=""></div>
                        <div className="d-flex align-items-center right"><Time /></div>
                    </div>
                </header>
                <StudentInfo currentClass={this.props.currentClass} onClose={this.props.onClose} />
                <form onSubmit={this.handleSubmit}>
                    <section className="login-wrap main-container d-flex justify-content-center align-items-center scroll-wrapper main-bg">
                        <ul className="card-container d-flex flex-column position-relative p-0 m-0">
                            <CardHeader pageTitles={this.props.pageTitles} />
                            <li className="card-body d-flex flex-column align-items-end scroll-wrapper">
                                <div className="warning main-bg w-100">
                                    <p className="text-center m-0">“좌석번호를 선택해 주세요.”</p>
                                </div>

                                <ul className="seat-container w-100 p-0">
                                    {this.props.seatNumbers.map(item => (
                                        <li className="seat">
                                            <input type="radio" id={item + 1} value={item + 1} name="seatNum" className="d-none" onClick={this.handleInfo} />
                                            <label htmlFor={item + 1} className={this.state.selectClass ? "student-number none" : "student-number"}><b className="seat-no">{item + 1}</b></label>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li className="card-footer d-flex justify-content-center align-items-center">
                                <Link to={this.state.pageMove}><button type="submit" className="btn main-btn select-btn fail-btn">다음</button></Link>
                            </li>
                        </ul>
                    </section>
                </form>
            </div>
        );
    }
}

export default SeatSelect;